<div class="content-wrapper" id="membershipPage2">
    <div class="membership-banner text-center">
        
        <div class="banner-object">
            <img class="d-md-none" src="assets/images/mob-banner-object.png" alt="">
            <img class="d-none d-md-block" src="assets/images/banner-object.jpg" alt="">
        </div>
        <div class="container">
            <div class="row align-items-md-center">
                <div class="col-md-6">
                    <div class="banner-details text-md-left">
                        <h1 class="banner-title text-uppercase">
                            THE ULTIMATE ALL-IN-ONE HEALTH AND WELLNESS APP
                        </h1>
                        <p class="banner-desc">
                            Take charge of your healthy lifestyle with MyLifeWell.
                        </p>
                        <a  (click)="goToFreeSubscription()" class="btn btn-trail d-none d-md-inline-block cta-hero">
                            Activate 14-Day Free Membership
                        </a>
                        <h6 class="colorLightBlue fontWeight600" style="padding: 10px 15px;" >
                            Plus get 50% off your first month with code NEWUSER50
                        </h6>
                    </div>
                    
                </div>
                <div class="col-md-6">
                    <figure class="banner-devices">
                        <img src="assets/images/membership/14-day-free-trialWIthDiscount.png" alt="mylifewell">
                    </figure>
                    <!-- *ngIf="showButtonForPlanPageRoute" -->
                    <a (click)="goToFreeSubscription()" class="btn btn-trail d-md-none cta-hero">
                        Activate 14 Day Free Membership
                    </a>
                </div>
            </div>
            <a class="exp-link" style="text-align: -webkit-center;" (click)="scrollToViewOfExploreSection()">
                <span class="arrow d-flex align-items-center justify-content-center cursorHand">
                    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-long-arrow-down fa-w-8 fa-2x"><path fill="#a5a5a5" d="M252.485 343.03l-7.07-7.071c-4.686-4.686-12.284-4.686-16.971 0L145 419.887V44c0-6.627-5.373-12-12-12h-10c-6.627 0-12 5.373-12 12v375.887l-83.444-83.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l116 116.485c4.686 4.686 12.284 4.686 16.971 0l116-116.485c4.686-4.686 4.686-12.284-.001-16.97z" class=""></path></svg>
                </span>
                <span class="txt text-uppercase">
                    Explore the App
                </span>
            </a>
        </div>
    </div>
    <div class="fitness-sec text-center">
        <div class="container">
            <div class="main-heading">
                <h2 class="main-title text-capitalize">
                    Your one-stop app to a healthier lifestyle.
                </h2>
                <p class="main-desc">
                    We created the MyLifeWell App to help you take care of all your wellness goals in one single place.
                </p>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <figure class="device-img">
                        <img src="assets/images/fitness-device.jpg" alt="">
                    </figure>
                </div>
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="fitness-card">
                                <span class="counter-txt">1</span>
                                <span class="fitness-icn"><img src="assets/images/fitness-icn01.png" alt=""></span>
                                <h4 class="crd-title text-uppercase">
                                    Physical
                                </h4>
                                <p class="crd-desc">
                                    Support and maintain a healthy body through fitness classes, personalized workouts & nutrition tracking.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="fitness-card">
                                <span class="counter-txt">2</span>
                                <span class="fitness-icn"><img src="assets/images/fitness-icn02.png" alt=""></span>
                                <h4 class="crd-title text-uppercase">Mental</h4>
                                <p class="crd-desc">
                                    Create a strong and healthy mind through guided meditations and stress management programs.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="fitness-card">
                                <span class="counter-txt">3</span>
                                <span class="fitness-icn"><img src="assets/images/fitness-icn03.png" alt=""></span>
                                <h4 class="crd-title text-uppercase">Social</h4>
                                <p class="crd-desc">
                                    Connect and engage with other like minded members to support and motivate each other.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="fitness-card">
                                <span class="counter-txt">4</span>
                                <span class="fitness-icn"><img src="assets/images/fitness-icn04.png" alt=""></span>
                                <h4 class="crd-title text-uppercase">Emotional</h4>
                                <p class="crd-desc">
                                    Promote emotional well-being with the help of wellness coaches & experts.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="app-features text-center" id="exploreAWorldOfWellnessDiscountPage">
        <div class="container">
            <div class="main-heading">
                <h2 class="main-title text-capitalize">
                    Explore A World Of Wellness at Your Fingertips
                </h2>
                <p class="main-desc">   
                    MyLifeWell integrates wellness across multiple dimensions making it more fun and easy to adopt a wellness lifestyle.
                </p>
                
            </div>
            <a  (click)="goToFreeSubscription()" class="btn btn-trail cta-midpage">
                Try it Free for 14 Days
            </a>
            <h6 class="colorLightBlue fontWeight600" style="padding: 10px 15px;" *ngIf="">
                Offer ends Sept 15, 2021.
            </h6>
            <div class="feature-wrp">
                <div class="feature-device">
                    <img class="d-md-none" src="assets/images/app-device.png" alt="">
                    <img class="d-none d-md-block" src="assets/images/app-device-feature.png" alt="">
                    <h2 class="device-title text-uppercase">Mobile App <span>Features</span></h2>
                </div>
                <ul class="feature-list">
                    <li>
                        <div class="feature-detail">
                            <span class="fitness-icn">
                                <img src="assets/images/feature-icn01.png" alt="">
                            </span>
                            <h4 class="crd-title text-uppercase">
                                MINDFULNESS
                            </h4>
                            <p class="crd-desc">
                                Guided meditations and calming music to nurture your mental and emotional wellbeing.
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="feature-detail">
                            <span class="fitness-icn">
                                <img src="assets/images/feature-icn02.png" alt="">
                            </span>
                            <h4 class="crd-title text-uppercase">
                                Classes-on-Demand
                            </h4>
                            <p class="crd-desc">
                                Move with 2,000+ different guided classes and programs, from yoga to HIIT, kettlebells to barre.
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="feature-detail">
                            <span class="fitness-icn"><img src="assets/images/feature-icn03.png" alt=""></span>
                            <h4 class="crd-title text-uppercase">CHALLENGES </h4>
                            <p class="crd-desc">
                                Challenge your friends and family, track your progress and earn badges.
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="feature-detail">
                            <span class="fitness-icn"><img src="assets/images/feature-icn04.png" alt=""></span>
                            <h4 class="crd-title text-uppercase">
                                PERSONALIZED
                            </h4>
                            <p class="crd-desc">
                                Create a personalized calendar or set up personalized reminders to build healthy habits.
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="feature-detail">
                            <span class="fitness-icn"><img src="assets/images/feature-icn05.png" alt=""></span>
                            <h4 class="crd-title text-uppercase">
                                NUTRITION
                            </h4>
                            <p class="crd-desc">
                                Track your nutrition and caloric goals by easily inputting meals, ingredients and barcodes.
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="feature-detail">
                            <span class="fitness-icn"><img src="assets/images/feature-icn06.png" alt=""></span>
                            <h4 class="crd-title text-uppercase">
                                Groups and Communities
                            </h4>
                            <p class="crd-desc">
                                Join groups of your interest led by certified coaches and talk to like minded members.
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="feature-detail">
                            <span class="fitness-icn"><img src="assets/images/feature-icn07.png" alt=""></span>
                            <h4 class="crd-title text-uppercase">
                                CUSTOM WORKOUTS
                            </h4>
                            <p class="crd-desc">
                                Create your own workouts from 5,000+ 3D exercise videos with step-by-step movement instructions.
                            </p>
                        </div>
                    </li>
                    <li class="d-none d-md-block">
                        <div class="feature-detail">
                            <span class="fitness-icn">
                                <img src="assets/images/feature-icn07.png" alt="">
                            </span>
                            <h4 class="crd-title text-uppercase">
                                Integrated Health
                            </h4>
                            <p class="crd-desc">
                                Connects with Apple Health, Google Fit, Fitbit and NEO Health wearables.
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="advantage-sec text-center">
        <span class="divider"><img src="assets/images/divider-img.png" alt=""></span>
        <div class="container">
            <div class="main-heading">
                <h2 class="main-title text-capitalize">
                    The MyLifeWell Advantage
                </h2>
                <p class="main-desc">
                    All app subscribers get access to the following MyLifeWell services:
                </p>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="adv-card first-adv">
                        <span class="adv-icn">
                            <img src="assets/images/membership/banner-devices-circle.jpg" alt="">
                        </span>
                        <h4 class="adv-title text-uppercase">
                            MyLifeWell App
                        </h4>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="adv-card ">
                        <span class="adv-icn"><img src="assets/images/travel-adv.jpg" alt=""></span>
                        <h4 class="adv-title text-uppercase">
                            TRAVEL WELL
                        </h4>
                        <p class="adv-desc">
                            Priority access to exclusive wellness trips and promotions.
                        </p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="adv-card">
                        <span class="adv-icn">
                            <img src="assets/images/comming-soon-banner.jpg" alt="">
                        </span>
                        <h4 class="adv-title text-uppercase">
                            SHOP WELL
                        </h4>
                        <p class="adv-desc">
                            Exclusive discounts on wellness products.
                        </p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="adv-card">
                        <span class="adv-icn"><img src="assets/images/learn-adv.jpg" alt=""></span>
                        <h4 class="adv-title text-uppercase">
                            Learn Well
                        </h4>
                        <p class="adv-desc">
                            Access to premium wellness programs curated by MyLifeWell instructors.
                        </p>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
    <div class="app-work text-center">
        <span class="divider">
            <img src="assets/images/divider-img.png" alt="myLifeWell">
        </span>
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <figure class="device-img">
                        <img src="assets/images/work-device.png" alt="myLifeWell">
                    </figure>
                </div>
                <div class="col-md-6">
                    <div class="main-heading d-none d-lg-block text-lg-left">
                        <h2 class="main-title">
                            Get Your First Trial Free
                        </h2>
                    </div>
                    <ul class="feature-list text-left">
                        <li>
                            <div class="feature-detail">
                                <span class="fitness-icn">
                                    <img src="assets/images/user-work.png" alt="myLifeWell">
                                </span>
                                <h4 class="crd-title text-uppercase">
                                    Sign Up 
                                    <!-- BEFORE AUGUST 15, 2021. -->
                                </h4>
                                <p class="crd-desc">
                                    Create your account.
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="feature-detail">
                                <span class="fitness-icn"><img src="assets/images/download-icn.png" alt=""></span>
                                <h4 class="crd-title text-uppercase">
                                    Activate
                                </h4>
                                <p class="crd-desc">
                                    Complete and activate your membership
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="feature-detail">
                                <span class="fitness-icn">
                                    <img src="assets/images/favicon.png" alt="mylifewell">
                                </span>
                                <h4 class="crd-title text-uppercase">
                                    Your First Trial is on us!
                                </h4>
                                <p class="crd-desc">
                                    Enjoy 14 days of unlimited access immediately to the MyLifeWell App.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="freetrial-banner text-center">
        <picture>
            <source media="(min-width:768px)" srcset="assets/images/trial-banner-1920.jpg" />
            <img class="banner-img" src="assets/images/trial-banner-320.jpg" alt="BannerImg" />
        </picture>
        <div class="container">
            <div class="trail-detail d-md-flex align-items-center">
                <div>
                    <p style="font-family: 'Caveat', cursive;font-size: 3.7rem;color: white;margin-bottom: 20px;">
                        Not just a fitness app
                    </p>
                    <h2 class="trial-title">
                        Activate 14-Day Free Membership
                        <!-- Get Your First 3 Months Free -->
                    </h2>
                    <p class="trail-desc" >
                    $19.90 per month
                    </p>
                    <a (click)="goToFreeSubscription()" class="btn btn-trail cta-banner">
                        Claim Your Free Trial Today
                    </a>
                    <h6 class="" *ngIf="">
                        Offer ends Sept 15, 2021.
                    </h6>
                </div>
            </div>
        </div>
    </div>
    <div class="carousal-sec meet-instructors text-center">
        <div class="container">
            <div class="main-heading">
                <h2 class="main-title text-capitalize">
                    Meet Your Instructors
                </h2>
            </div>
            <ngx-slick-carousel class="carousel"  [config]="slideConfigForInstructor" >
                <div class="slide-item" ngxSlickItem *ngFor="let i of instructorData">
                    <figure>
                        <img [src]="i?.imgSrc">
                    </figure>
                    <div class="info">
                        <h6 class="ins-name">
                            {{ i?.name }}
                        </h6>
                        <p class="ins-designation">
                           {{ i?.designation }} 
                        </p>
                    </div>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
    <div class="carousal-sec quick-view text-center">
        <div class="container">
            <div class="main-heading">
                <h2 class="main-title text-capitalize">
                    At-a-Glance
                </h2>
            </div>
            
        </div>
        <ngx-slick-carousel class="carousel"  [config]="slideConfigForVideos" >
            <div class="slide-item" ngxSlickItem *ngFor="let i of quickViewImages">
                <img class="device-frame" src="assets/images/device-frame.png" alt="">
                <div class="device-content">
                    <img [src]="i?.imgSrc" alt="mylifewell">
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="goto-premium text-center" >
        <div class="container">
            <div class="main-heading">
                <h2 class="main-title text-capitalize">
                    Features
                </h2>
            </div>
            <div class="premium-plan d-md-flex">
                <div class="premium-banner d-none d-md-block">
                    <img src="assets/images/premium-banner.jpg" alt="">
                </div>
                <div class="plan-detail  text-left">
                    
                    <span class="discount-bg" *ngIf="this.plan == 'Premium Plan'">
                        <img src="assets/images/discount-bg.png" alt="bg">
                        <span class="discount-txt text-uppercase" >
                            Save {{ planInfo?.data?.shopDiscount ? planInfo?.data?.shopDiscount : '25'  }}%
                        </span>
                    </span>
                    <h4 class="pan-title" style="text-transform: none;color: black;">
                        Unlimited wellness for as little as $19.90 per month.
                    </h4>
                    <div class="plan-price" *ngFor="let i of planInfo?.data?.planDurationObject">
                        <div *ngIf="this.plan == 'Premium Plan' && i?.type == 'yearly'">
                            <span> {{ i?.price/12  | currency:'USD':'symbol':'1.2-2' }} 
                                <sub class="bottom2px">/Month</sub>
                                <span style="font-size: 16px;margin-left: 10px;">
                                    ( 
                                    {{ i?.price  | currency:'USD':'symbol':'1.2-2' }} 
                                <sub class="bottom2px">/Year</sub>
                                )
                                </span>
                            </span>
                        </div>
                        <div *ngIf="false && this.plan == 'Monthly Plan' && i?.type == 'monthly'">
                            <span>{{ i?.price  | currency:'USD':'symbol':'1.2-2' }} 
                                <sub>/Month</sub>
                            </span>
                        </div>
                    </div>
                    <ul class="plan-list">
                        <li *ngFor="let i of planInfo?.data?.details">
                            <em class="tick-icn" *ngIf="i?.inPlan == '1'">
                                <img src="assets/images/tick-green-icn.png" alt="mylifewell">
                            </em>
                            <em class="tick-icn" *ngIf="i?.inPlan == '0'">
                                <img src="assets/images/icon/cross.png" alt="MyLifeWell" class="crossIcon">
                            </em>
                            {{ i?.sub_detail}}
                        </li>
                    </ul>
                    <a  (click)="goToFreeSubscription()" class="btn btn-trail cta-pricechart">
                        Get Started
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="faq-section">
        <div class="container">
            <div class="main-heading">
                <h2 class="main-title text-capitalize">
                    Frequently Asked Questions
                </h2>
            </div>
            <ul class="faq-list">
                <li class="accordian" (click)="accordianChange(0)">
                    <h3>Q. How do I activate the free 14-day membership?
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            To activate your free trial, simply signup and complete your registration details. Once submitted, you'll get an email from us with your app download and login details so you can start enjoying three months of unlimited access. 
                        </p>
                    </div>
                </li>
                <li class="accordian" (click)="accordianChange(1)">
                    <h3>Q. How Is MyLifeWell Different Than Other Wellness Apps?
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            Comprehensive: You probably have to subscribe to 3-4 different apps to find the right on-demand classes, guided meditations, social support groups, personal training, nutrition and caloric tracking. MyLifeWell brings everything together in one seamless app making it easier to adopt a wellness lifestyle in your day-to-day life.
                            <br>
                            <br>
                            Variety: The MyLifeWell app offers 2000+ Yoga, HIIT, Barre, Kettlebell, Dance, Kick Boxing, Meditation, Cycling, Breathwork, Pilates and even Ballet bootcamp classes to choose from. Try something different each day and who knows, you may find a new passion! In addition, we offer 5000+ 3D animated videos for creating custom at-home and gym workouts.
                            <br>
                            <br>
                            Quality:  We make sure that you get only the best content across all categories.
                        </p>
                    </div>
                </li>
                <li class="accordian" (click)="accordianChange(2)">
                    <h3>Q. Do I Need A Lot Of Equipment To Work Out?
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            Not at all. We have a lot of classes that do not require any equipment. If you want to use an equipment then you can quickly filter the classes by different equipment options such as dumbell, kettlebell, resistance band and so on.
                        </p>
                    </div>
                </li>
                <li class="accordian" (click)="accordianChange(3)">
                    <h3>Q. Do I have to be experienced to do the classes? 
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            Not at all. We have classes whether it’s your first time or you work out all the time. Start with where you’re at and build up from there, you’ll be surprised at how quickly you learn and grow.
                        </p>
                    </div>
                </li>
                <li class="accordian" (click)="accordianChange(4)">
                    <h3>Q. I don’t have a lot of time, how long are the classes? 
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            We have classes ranging from 5 min to hour long fitness classes. So, whether you are looking for a quick 10 min office workout or a 60 min full body workout, we have got you covered.
                        </p>
                    </div>
                </li>
                <li class="accordian" (click)="accordianChange(5)">
                    <h3>Q. Do you have a rewards program?
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            We will soon be launching a rewards program which means that not only will you be leading a healthier lifestyle but you will also be rewarded for it. Is there anything better?!!
                        </p>
                    </div>
                </li>
                <li class="accordian" (click)="accordianChange(6)">
                    <h3>Q.If the first 14-day is free, why do I have to enter a credit card?  
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            When you sign up for your free 14-days of unlimited access, you are enrolling in a MyLifeWell subscription product. Your card will not be charged during the free month's membership period. At the end of the free membership period, the card will be charged per your subscription plan. You can cancel your membership at any time before or after the end of the free membership period. 
                        </p>
                    </div>
                </li>
                <li class="accordian" (click)="accordianChange(7)">
                    <h3>Q. What is the regular monthly cost after the 14-days Free Trial?
                        <span class="plus-wrap"></span>
                    </h3>
                    <div class="faq-content">
                        <p>
                            <!-- The regular monthly membership fee is $19.90 USD/month. -->
                            We have two subscription plans: the Monthly Plan is $19.90/month and the Quarterly Plan is $14.90/month paid every three months.
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <app-subscribe-newsletter></app-subscribe-newsletter>
    <app-modal-pop-up [responseMessage]="popUpMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
    </app-modal-pop-up>
</div>